import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { CONTACT } from "../../mock";

export const waLink = (msg = "Bonjour Ouest Conciergerie, je souhaite des informations pour mon logement.") =>
  `https://wa.me/33${CONTACT.whatsapp.replace(/\s/g, "").replace(/^0/, "")}?text=${encodeURIComponent(msg)}`;

export function WhatsAppIcon({ className = "" }) {
  return (
    <svg viewBox="0 0 32 32" className={className} fill="currentColor" aria-hidden="true">
      <path d="M16.04 3C9.4 3 4 8.37 4 14.98c0 2.11.56 4.17 1.62 5.99L4 29l8.25-1.6a12.1 12.1 0 0 0 3.79.6C22.68 28 28 22.63 28 16.02 28 8.37 22.68 3 16.04 3Zm0 22.9c-1.2 0-2.38-.2-3.5-.6l-.25-.09-4.9.95.97-4.75-.16-.27a9.83 9.83 0 0 1-1.52-5.16c0-5.47 4.47-9.92 9.36-9.92 5.48 0 9.86 4.45 9.86 9.92 0 5.47-4.38 9.92-9.86 9.92Zm5.43-7.43c-.3-.15-1.76-.86-2.03-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.47-.88-.79-1.48-1.76-1.66-2.06-.17-.3-.02-.46.13-.6.13-.14.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.6-.92-2.2-.24-.57-.49-.5-.67-.5h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.01-1.04 2.47 0 1.46 1.07 2.87 1.21 3.07.15.2 2.1 3.2 5.08 4.48.71.31 1.27.49 1.7.63.72.23 1.37.2 1.88.12.57-.09 1.76-.72 2-1.41.25-.7.25-1.29.18-1.41-.07-.13-.27-.2-.57-.35Z" />
    </svg>
  );
}

export default function WhatsAppButton() {
  const [bubble, setBubble] = useState(false);
  useEffect(() => {
    if (sessionStorage.getItem("oc_wa_closed")) return;
    const t = setTimeout(() => setBubble(true), 4000);
    return () => clearTimeout(t);
  }, []);
  const close = () => { setBubble(false); sessionStorage.setItem("oc_wa_closed", "1"); };

  return (
    <div className="fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-[60] flex items-end gap-3" data-testid="whatsapp-widget">
      {bubble && (
        <div className="hidden sm:block relative bg-white rounded-2xl rounded-br-md shadow-[0_20px_50px_-15px_rgba(19,38,28,0.45)] ring-1 ring-[#e6dcc8] p-4 pr-9 max-w-[240px] animate-in fade-in slide-in-from-bottom-3 duration-500" data-testid="whatsapp-bubble">
          <button onClick={close} aria-label="Fermer" data-testid="whatsapp-bubble-close" className="absolute top-2 right-2 w-6 h-6 grid place-items-center rounded-full hover:bg-[#f1ebdd] text-[#6d7268]"><X className="w-3.5 h-3.5" /></button>
          <p className="text-sm font-bold text-[#13261c]">Une question ?</p>
          <p className="text-sm text-[#5a6158] mt-0.5">Écrivez-nous sur WhatsApp, on vous répond du lundi au samedi, de 10h à 18h.</p>
        </div>
      )}
      <a
        href={waLink()}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Nous écrire sur WhatsApp"
        data-testid="whatsapp-button"
        onClick={() => setBubble(false)}
        className="group relative w-16 h-16 rounded-full bg-[#25D366] hover:bg-[#1ebe5b] text-white grid place-items-center shadow-[0_15px_35px_-10px_rgba(37,211,102,0.8)] transition-[background-color,transform] duration-300 hover:scale-105 shrink-0"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25" />
        <WhatsAppIcon className="w-8 h-8 relative" />
      </a>
    </div>
  );
}
